import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { useStateValue } from "../../context/store";
import Logo from "../../images/sae.png";
import { VALUES } from "../../utils/constants";
import { LEARNING, REDASH_REPORT } from "../../constants";
import {
  makeStyles,
  AppBar,
  Toolbar,
  IconButton,
  Avatar,
  Typography,
  Link,
  Tooltip,
} from "@material-ui/core";
import { Menu } from "@material-ui/icons";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import AssignmentIcon from "@material-ui/icons/Assignment";
import Learning from "../../images/icons/Learning.svg"
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  appBar: {
    minHeight: 42,
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "#4D8D9D",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarClose: {
    backgroundColor: "#4D8D9D",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShiftClose: {
    marginLeft: VALUES.MENU.DRAWER_WIDTH,
    width: "83%",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  appBarShift: {
    marginLeft: VALUES.MENU.DRAWER_WIDTH,
    width: "100%",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  toolbar: {
    minHeight: 48,
    display: "flex",
    justifyContent: "space-between",
    background: "#4D8D9D",
    boxShadow: "10px 5px 5px #00000014",
  },
  toolbarIconsContainer: {
    display: "flex",
    alignItems: "center",
    color: "white",
  },
  menuButton: {
    marginLeft: "-20px!important",
    color: "#ffffff",
  },
  hide: {
    display: "none",
  },
  avatar: {
    marginLeft: ".6em",
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  icons: {
    color: "#ffffff",
  },
}));

const Header = ({ toggleDrawer, isOpen, history, contenValueHome }) => {
  const classes = useStyles();
  const [{ breadCrumb }, dispatch] = useStateValue();
  const [newValueHome, setNewValueHome] = useState(0);
  const name = JSON.parse(localStorage.getItem("state"));

  contenValueHome(newValueHome);
  const handleListItemClick = (breadCrumb) => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: breadCrumb,
      index: -1,
    });
    history.push("/dashboard/home");
  };

  const goToHome = () => {
    history.push("/dashboard/home");
  };

  const handleListItemClickNotifications = (breadCrumb) => {
    // dispatch({
    //   type: "SET_BREADCRUMB",
    //   breadCrumbText: "Notificaciones",
    //   breadCrumbSubText: "Notificaciones",
    //   index: 101,
    // });
    // history.push("/dashboard/notifications");
  };

  const handleUrl = () => {
    history.push("");
  };

  const tales = REDASH_REPORT;

  return (
    <AppBar
      elevation={0}
      id="headerComponent"
      position="fixed"
      className={clsx(classes.appBar, {
        [classes.appBarShift]: !isOpen.left,
        [`${classes.appBarClose} ${classes.appBarShiftClose}`]: isOpen.left,
      })}
    >
      <Toolbar id="toolbarComponent" className={classes.toolbar}>
        <div className={classes.toolbarIconsContainer}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer("left", true)}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: isOpen.left,
            })}
          >
            <Menu />
          </IconButton>

          <React.Fragment>
            <div
              onClick={goToHome}
              style={{
                pointerEvents: "all",
              }}
            >
              <img
                src={Logo}
                width="100"
                height="29"
                alt=""
                style={{
                  paddingLeft: "20px",
                  marginRight: 15,
                  cursor: "pointer",
                }}
              />
            </div>
          </React.Fragment>

          <div className={classes.toolbarIconsContainer}>
            <Typography style={{ fontSize: "13px", color: "#ffffff" }}>
              {breadCrumb?.breadCrumbText}
            </Typography>
          </div>
        </div>
        <div className={classes.toolbarIconsContainer}>
          {/* <IconButton fontSize="small" className={classes.icons}>
            <SearchOutlinedIcon />
          </IconButton>
          <IconButton fontSize="small" className={classes.icons}>
            <AppsOutlinedIcon />
          </IconButton> */}
          {name?.infoToken?.type === "INTERNO" && (
            <Tooltip title="Aprendizaje">
              <IconButton fontSize="small" className={classes.icons}>
                <a style={{ color: "#ffffff" }}
                  href={LEARNING} target="_blank">
                  <img src={Learning}
                    alt="learning"
                    style={{ width: "25px" }}
                  />
                </a>

              </IconButton>
            </Tooltip>)}

          < Tooltip title="Inicio">
            <IconButton fontSize="small" className={classes.icons}>
              <HomeOutlinedIcon onClick={() => handleListItemClick("Inicio")} />
            </IconButton>
          </Tooltip>
          {name?.infoToken?.type === "INTERNO" && (
            <>
              {" "}
              <Tooltip title="Reportes">
                <IconButton
                  fontSize="small"
                  className={classes.icons}
                  style={{ color: "#ffffff", marginTop: "4px" }}
                >
                  <a style={{ color: "#ffffff" }}
                    href={REDASH_REPORT} target="_blank">
                    <AssignmentIcon
                    // onClick={() =>
                    //   window.open({REDASH_REPORT}, "_blank")
                    // }
                    />
                  </a>

                </IconButton>
              </Tooltip>
              <Tooltip title="Notificaciones">
                <IconButton fontSize="small" className={classes.icons}>
                  <NotificationsNoneIcon
                    onClick={() =>
                      handleListItemClickNotifications("Notificaciones")
                    }
                  />
                </IconButton>
              </Tooltip>
            </>
          )}
          {/* <IconButton fontSize="small" className={classes.icons}>
            <ContactSupportOutlined />
          </IconButton> */}
          <Avatar
            src={require(`../../images/user1.jpg`)}
            className={classes.avatar}
          />
        </div>
      </Toolbar>
    </AppBar >
  );
};

export default withRouter(React.memo(Header));
